import { render, staticRenderFns } from "./liveHeadList.vue?vue&type=template&id=b59d8506&"
import script from "./liveHeadList.vue?vue&type=script&lang=js&"
export * from "./liveHeadList.vue?vue&type=script&lang=js&"
import style0 from "./liveHeadList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports